//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_SCREEN_DATA_BUSQUEDA_CLIENTE = 'GET_SCREEN_DATA_BUSQUEDA_CLIENTE';
export const RELOAD_BUSQUEDA_CLIENTE = 'RELOAD_BUSQUEDA_CLIENTE';
export const RELOAD_BUSQUEDA_CLIENTE_TARJETAS = 'RELOAD_BUSQUEDA_CLIENTE_TARJETAS';
export const CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE = 'CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE';
export const RESET_BUSQUEDA_CLIENTE = 'RESET_BUSQUEDA_CLIENTE ';
export const ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH = 'ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH';
export const ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE = 'ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE';
export const ROUTE_TO_VISTA_GESTION_CLIENTE_BUSQUEDA_CLIENTE = 'ROUTE_TO_VISTA_GESTION_CLIENTE_BUSQUEDA_CLIENTE';
export const SET_DATA_CLIENTE = 'SET_DATA_CLIENTE';
export const RESET_STATE_BUSQUEDA_CLIENTE = 'RESET_STATE_BUSQUEDA_CLIENTE';
export const SET_CLIENTES_ENCONTRADOS = 'SET_CLIENTES_ENCONTRADOS';
export const SET_CLIENTE_NO_ENCONTRADO = 'SET_CLIENTE_NO_ENCONTRADO';
export const SET_CLAIMS = 'SET_CLAIMS';



let _dispatch = null;

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, state, currentScope);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: GET_SCREEN_DATA_BUSQUEDA_CLIENTE, state });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => {
            _loadClientSearchFunctions(data);
            LogHelper.Out(getScreenData.name, data);
        }, null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * Búsqueda de cliente por DNI.
 * @param {any} doc
 * @param {any} obtenidoDePadron
 */
export function buscarPorDni(doc, esAdicional) {
    LogHelper.In(buscarPorDni.name, doc, esAdicional);

    var programaActual = JSON.parse(localStorage.getItem('programaActual'));

    return (dispatch, getState) => {

        _dispatch = dispatch;

        //var programaSelccionado = getState().busquedaCliente.lastProgram;
       

        let param = {
            'nroDocumento': doc
        }

        LogHelper.Out(buscarPorDni.name, param, 'GETCLIENTES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');


        //  AddDataSourcesRequests: function (localValues, key, requestType, product, category, value, cacheKeyLevel, isQuery, resultId) {
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CLIENTE_NRODOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true, 'clientesObtenidos');


        Engine1Proxy.Execute((data) => _callBackBuscarPorDocumento(data, doc, programaActual), null, null, "CONSULTASOCIOS");

        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE });
        _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE_TARJETAS, payload: true });

    }
}

/**
 * funcion de retorno exitoso al buscar los clientes.
 * @param { any } data
 */
function _callBackBuscarPorDocumento(data, nroDocumento, programaSelccionado) {

    var clientesEncontrados = JSON.parse(data.clientesObtenidos).Recordset0.Rows;



    switch (clientesEncontrados.length) {
        case 0:
            // no se a encontrado ningún resultado
            _dispatch({ type: SET_CLIENTE_NO_ENCONTRADO })
            break;
        case 1:
            // se ha econtrado un unico cliente se debe avanzar a la siguente pantalla
            _dispatch(seleccionarCliente(clientesEncontrados[0], nroDocumento, programaSelccionado));
            break;
        default:
            //se han encontrado varias coincidencias
            _dispatch({ type: SET_CLIENTES_ENCONTRADOS, clientesEncontrados, nroDocumento, programaSelccionado });
            break;
    };
}

export function seleccionarCliente(clienteSeleccionado, nroDocumento, programaSelccionado) {

    return (dispatch) => {

        _dispatch = dispatch;

        _cargarClienteEncontrado(clienteSeleccionado, nroDocumento);

        if (programaSelccionado == 'SOCIOS')
            //avanzo a la pantalla de cuentas
            _dispatch({ type: ROUTE_TO_VISTA_CLIENTE_BUSQUEDA_CLIENTE });
        else
            //avanzo a la pantalla de cientes
            _dispatch({ type: ROUTE_TO_VISTA_GESTION_CLIENTE_BUSQUEDA_CLIENTE });
    }

}

function _cargarClienteEncontrado(clienteEncontrado, nroDocumento) {

    let cliente = clienteEncontrado;
    cliente.Documento = nroDocumento;
    let fechaNacimiento = clienteEncontrado && clienteEncontrado.FechaNacimiento ? (clienteEncontrado.FechaNacimiento.split("T")[0]).replace(/-/g, "") : "";

    let clienteFinal = {
        APELLIDO: clienteEncontrado.Apellido,
        ApellidoCompleto: clienteEncontrado.Apellido,
        NombreCompleto: clienteEncontrado.Nombre,
        CliNum: clienteEncontrado.Id,
        CuentaCliente: '',
        Cuit: clienteEncontrado.Cuit,
        NumeroDocumento: nroDocumento,
        identidadCliente: `${clienteEncontrado.Nombre} ${clienteEncontrado.Apellido} `,
        NOMBRE: clienteEncontrado.Nombre,
        NUMERO_DOCUMENTO: nroDocumento,
        NUMERO_DOCUMENTO_FORMATO: undefined,
        Nacionalidad: clienteEncontrado.NacionalidadId,
        NombreCompleto: clienteEncontrado.Nombre + clienteEncontrado.Apellido,
        RAZON_SOCIAL: "",
        TIPO_DOCUMENTO: clienteEncontrado.Codigo,
        TIPO_DOCUMENTO_ID: clienteEncontrado.TipoDocumentoId,
        clienteListaDocumentos: [],
        codigoCabalDoc: "",
        esPersonaFisica: true,
        estadoCivil: clienteEncontrado.EstadoCivil,
        estadoCivilId: clienteEncontrado.EstadoCivilId,
        gananciasId: null,
        iva: clienteEncontrado.CategoriaIVA,
        limiteCompraEmpresaOperativa: null,
        limiteFormato: "",
        ocupacion: clienteEncontrado.Ocupacion,
        ocupacionId: clienteEncontrado.OcupacionId,
        pais: clienteEncontrado.Pais,
        seEncontroEnDB: true,
        tipoCliente: clienteEncontrado.FisicaJuridica,
        tipoIibbCodigo: undefined,
        tipoIva: clienteEncontrado.CategoriaIvaId,
        IIBBId: null,
        Id: clienteEncontrado.Id,
        LimitePorCuit: "",
        DatosClientes:
        {
            Id: clienteEncontrado.Id,
            TipoDocumentoId: clienteEncontrado.TipoDocumentoId,
            NumeroDocumento: nroDocumento,
            TipoPersona: clienteEncontrado.FisicaJuridica,
            RazonSocial: "",
            Apellido1: clienteEncontrado.Apellido,
            Apellido2: "",
            Nombre1: clienteEncontrado.Nombre,
            Nombre2: "",
            Nombre3: "",
            Sexo: clienteEncontrado.Sexo,
            FechaNac: fechaNacimiento,
            Nacionalidad: clienteEncontrado.NacionalidadId,
            EstadoCivil: clienteEncontrado.EstadoCivilId,
            ActEconomica: "",
            SucursalResp: "",
            NombreCompleto: clienteEncontrado.Apellido,
            ApellidoCompleto: clienteEncontrado.Nombre,
        },
        Domicilios: [],
        DomiciliosCliente: {},
        MailsCliente: [],
        TelefonosCliente: {},
        resultadoBD: {
            Apellido: clienteEncontrado.Nombre,
            CategoriaIvaId: clienteEncontrado.CategoriaIvaId,
            ClienteBancoNumero: null,
            Cuit: clienteEncontrado.Cuit,
            DESCRIPCION: clienteEncontrado.CategoriaIVA,
            EstadoCivilId: clienteEncontrado.EstadoCivilId,
            FechaAlta: null,
            FechaNacimiento: fechaNacimiento,
            FechaUltimaModificacion: null,
            FisicaJuridica: clienteEncontrado.FisicaJuridica,
            Id: clienteEncontrado.Id,
            NacionalidadId: clienteEncontrado.NacionalidadId,
            Nombre: clienteEncontrado.Nombre,
            NumeroDocumento: nroDocumento,
            OcupacionId: clienteEncontrado.OcupacionId,
            RazonSocial: null,
            Sexo: clienteEncontrado.Sexo,
            SolicitudId: null,
            TipoDocumentoId: clienteEncontrado.TipoDocumentoId,
            TipoIibbId: null
        }
    }
    _dispatch({ type: SET_DATA_CLIENTE, cliente });
    _dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH, cliente: clienteFinal });
}

/**
 * Carga de funciones de la pantalla.
 * @param { any } data
 */
function _loadClientSearchFunctions(data) {

    LogHelper.In(_loadClientSearchFunctions.name, data);

    _dispatch({ type: SET_CLAIMS, claims: data });
    
    LogHelper.Out(_loadClientSearchFunctions.name, data);
}



/**
 * Actualización el valor de búsqueda.
 * @param {any} value
 */
export function cambiarBusqueda(value) {
    LogHelper.In(cambiarBusqueda.name, value);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: CHANGE_VALUE_SEARCH_BUSQUEDA_CLIENTE,
            newSerchValue: value
        });
        if (value.length < 3) {
            dispatch({
                type: RESET_BUSQUEDA_CLIENTE
            });
        }
    }
}

/** 
 * Resetea el state de la pantalla.
 */
export function resetStateBusquedaCliente() {
    LogHelper.In(resetStateBusquedaCliente.name);

    return (dispatch) => {
        _dispatch = dispatch;

        dispatch({
            type: RESET_STATE_BUSQUEDA_CLIENTE
        });
    }
}